import React from "react";
import { useNavigate } from "react-router";
import Toaster from "../../components/common/toaster";
import { useFormik } from "formik";
import * as Yup from "yup";
import { login, setLoggedIn } from "../../store/slice/auth";
import { useDispatch } from "react-redux";
import { toastSuccess } from "../../common/toastNotification";
import { CommonTextField } from "../../components/widgets/common_textField";
import CommonButton from "../../components/widgets/common_button";
import Logo from "../../assets/svg/logo.svg";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*_,]/,
        "Password must contain at least one special character"
      )
      .required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await dispatch(login(values)).unwrap();

      localStorage.setItem("isLoggedIn", "true");
      dispatch(setLoggedIn(true));

      toastSuccess("Admin Login Successfully");
      navigate("/");
    } catch (error) {
      Toaster(
        "error",
        error?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <div className="flex items-center justify-center h-screen w-full">
      <div className="max-w-3xl w-full px-5">
        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8 w-full border-input border h-fit rounded-md shadow-lg">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <a href="/" className="flex items-center gap-2 justify-center">
              <div className="w-20 lg:w-48">
                <img src={Logo} alt="logo" className="w-full" />
              </div>
            </a>
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight dark:text-white text-gray-900">
              Sign In
            </h2>
          </div>

          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <form className="mt-10 space-y-6" onSubmit={formik.handleSubmit}>
              <div className="grid gap-1.5">
                <CommonTextField
                  label="Email"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && formik.errors.email}
                />
              </div>

              <div className="grid gap-1.5">
                <CommonTextField
                  label="Password"
                  type="password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Password"
                  isPassword
                  error={formik.touched.password && formik.errors.password}
                />
              </div>

              <CommonButton
                type="submit"
                className="w-full"
                isLoading={formik.isSubmitting}
              >
                Sign In
              </CommonButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
